import React from "react";

const Privacy = () => {
  return (
    <main style={{ textAlign: "justify", padding: '20px' }}>
      <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
      <p>
        This privacy policy governs your use of the software application
        "WiMouse PC & Mac remote control" for Android and iOS devices, created
        by 503 Studios, available on the Google Play Store, Apple App Store, and
        at <a href="https://wimouse.web.app">wimouse.web.app</a>
        <br />
        <br />
        By using the Application, you are consenting to the collection and
        storage of your information as set forth in this Privacy Policy now and
        as amended by the developer.
        <br />
        <br />
        The Application does not collect any personal information. All the data
        is streamed directly to the connected WiMouse Server program. The access
        to the data streams are ruled by your Firewall settings, which are, in
        most cases, configured to block access from outside the local network by
        default. Enabling external access requires the user to manually
        configure the firewall and should be done at users own risk.
        <br />
        <br />
        You can erase all data stored by the Application by uninstalling it from
        the device using the standard uninstall processes as may be available as
        part of your Android system.
        <br />
        <br />
        Automatic Data Collection and Advertising: The Application may
        incorporate third party analytics tools to help understand how the
        Application is being used, such as the frequency and duration of usage.
        The Application may incorporate third party advertisers and third party
        advertising networks, who need to know how you interact with advertising
        provided in the Application which helps keep the cost of the Application
        low. Advertisers and advertising networks may collect additional
        information within the Application context, including, but not limited
        to, the unique identification ID of your mobile device, anonymous
        information about other applications you've downloaded to your mobile
        device, your non-precise location information, and other non-precise
        location information in order to help analyze and serve anonymous
        targeted advertising on the Application and elsewhere. Non-personally
        identifiable information is shared with AdMob and Google Play Services{" "}
        <a href="https://www.google.com/intl/en/policies/privacy/">
          (link to Google Privacy Policy)
        </a>
        <br />
        <br />
        Changes: This Privacy Policy may be updated from time to time for any
        reason. You are advised to consult this Privacy Policy regularly for any
        changes, as continued use is deemed approval of all changes.
        <br />
        <br />
        No error-free performance Programs does not guarantee error-free
        performance under this Privacy Policy. Programs may not always catch an
        unintended privacy issue, despite Author's efforts to do so. Your
        feedback regarding any privacy concerns that you may have is welcome.
        Author will use reasonable efforts to comply with this Privacy Policy
        and will take prompt action when he learns of any failure to comply with
        it.
        <br />
        If you have any questions or comments about this policy, please contact
        us: 503studiosapps@gmail.com.
      </p>
    </main>
  );
};

export default Privacy;
